import { render, staticRenderFns } from "./HomeSectionError.vue?vue&type=template&id=6c1da307"
import script from "./HomeSectionError.vue?vue&type=script&lang=js"
export * from "./HomeSectionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports